/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Vlt-icon-rec-full': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm2 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM12 6a6 6 0 100 12 6 6 0 000-12z"/>'
  }
})
